export class Version {
	private _name: string;
	private _version: string;
	private _error: string;

	constructor(name: string = null, version: string = null) {
		this._name = name;
		this._version = version;
	}

	hasError(): boolean {
		return this._error !== null;
	}

	get name(): string {
		return this._name;
	}

	set name(newName: string) {
		this._name = newName;
	}

	get version(): string {
		return this._version;
	}

	set version(newVersion: string) {
		this._version = newVersion;
	}

	get error(): string {
		return this._error;
	}

	set error(newError: string) {
		this._error = newError;
	}
}
